import React from "react";
import PropTypes from "prop-types";

export const STORE_UNIVERSE_LOAD_STATUS_TEST_ID = 'store-universe-load-status';
export const STORE_UNIVERSE_LOADED_COUNT_TEST_ID = 'store-universe-loaded-count';
export const STORE_UNIVERSE_PARTIAL_NOTE_TEST_ID = 'store-universe-partial-note';
export const LOAD_NEXT_STORES_BUTTON_TEST_ID = 'load-next-stores-button';
export const LOAD_ALL_STORES_BUTTON_TEST_ID = 'load-all-stores-button';
export const STORE_UNIVERSE_LOAD_ERROR_TEST_ID = 'store-universe-load-error';

const StoreUniverseLoadStatus = ({loadedCount, totalItemsCount, nextBatchSize, loadingMore = false, error, onLoadMore, onLoadAll}) => (
    <div className={'callout primary small store-universe-load-status'} data-testid={STORE_UNIVERSE_LOAD_STATUS_TEST_ID}>
        <span className={'store-universe-loaded-count'} data-testid={STORE_UNIVERSE_LOADED_COUNT_TEST_ID}>
            Showing {loadedCount.toLocaleString()} of {totalItemsCount.toLocaleString()} stores
        </span>
        {nextBatchSize > 0 && <>
            <span className={'store-universe-partial-note'} data-testid={STORE_UNIVERSE_PARTIAL_NOTE_TEST_ID}>
                Sorting and filtering apply to loaded stores only
            </span>
            <button type={'button'}
                    className={'button primary store-universe-load-next-button'}
                    data-testid={LOAD_NEXT_STORES_BUTTON_TEST_ID}
                    disabled={loadingMore}
                    onClick={onLoadMore}
            >
                {loadingMore ? 'Loading…' : `Load next ${nextBatchSize.toLocaleString()}`}
            </button>
            <button type={'button'}
                    className={'button store-universe-load-all-button'}
                    data-testid={LOAD_ALL_STORES_BUTTON_TEST_ID}
                    disabled={loadingMore}
                    onClick={onLoadAll}
            >
                Load all
            </button>
        </>}
        {error && <span className={'store-universe-load-error'} data-testid={STORE_UNIVERSE_LOAD_ERROR_TEST_ID}>{error}</span>}
    </div>
);

StoreUniverseLoadStatus.propTypes = {
    loadedCount: PropTypes.number.isRequired,
    totalItemsCount: PropTypes.number.isRequired,
    nextBatchSize: PropTypes.number.isRequired,
    loadingMore: PropTypes.bool,
    error: PropTypes.string,
    onLoadMore: PropTypes.func.isRequired,
    onLoadAll: PropTypes.func.isRequired,
};

export default StoreUniverseLoadStatus;
